
/*
|--------------------------------------------------------------------------
| Initial State
|--------------------------------------------------------------------------
*/
const initialState = {
  progress: null,
  section_id: '',
  section: {},
  section_data: {},
  lessons: [],
  lesson_data: {},
  lesson_content: {},
  lesson_modal: false,
  section_status: '',
  lesson_status: '',
  content_status: '',
};

/*
|--------------------------------------------------------------------------
| Mutations
|--------------------------------------------------------------------------
*/
const mutations = {
  setProgress(state, payload) {
    state.progress = payload
  },
  unsetProgress(state, payload) {
    state.progress = ''
  },
  setSection(state, payload) {
    state.section = payload
  },
  unsetSection(state, payload) {
    state.section = {}
  },
  setSectionData(state, payload) {
    state.section_data = payload
  },
  unsetSectionData(state) {
    state.section_data = {}
  },
  setLessons(state, payload) {
    state.lessons = [...payload]
  },
  unsetLessons(state, payload) {
    state.lessons.splice(0)
  },
  setLessonData(state, payload) {
    state.lesson_data = payload
  },
  unsetLessonData(state) {
    state.lesson_data = {}
  },
  setLessonContent(state, payload) {
    state.lesson_content = payload
  },
  unsetLessonContent(state) {
    state.lesson_content = {}
  },
  lessonModal(state, payload) {
    state.lesson_modal = payload
  },
  setSectionStatus(state, payload) {
    state.section_status = payload
  },
  unsetSectionStatus(state) {
    state.section_status = ''
  },
  setLessonStatus(state, payload) {
    state.lesson_status = payload
  },
  unsetLessonStatus(state) {
    state.lesson_status = ''
  },
  setContentStatus(state, payload) {
    state.content_status = payload
  },
  unsetContentStatus(state) {
    state.content_status = ''
  },
};

/*
|--------------------------------------------------------------------------
| Actions
|--------------------------------------------------------------------------
*/
const actions = {
  setProgress: (context, data) => {
    context.commit('setProgress', data)
  },
  unsetProgress: (context) => {
    context.commit('unsetProgress')
  },
  setSection: (context, data) => {
    context.commit('setSection', data)
  },
  unsetSection: (context) => {
    context.commit('unsetSection')
  },
  setSectionData: (context, data) => {
    context.commit('setSectionData', data)
  },
  unsetSectionData: (context) => {
    context.commit('unsetSectionData')
  },
  setLessons: (context, data) => {
    context.commit('setLessons', data)
  },
  unsetLessons: (context) => {
    context.commit('unsetLessons')
  },
  setLessonData: (context, data) => {
    context.commit('setLessonData', data)
  },
  unsetLessonData: (context) => {
    context.commit('unsetLessonData')
  },
  setLessonContent: (context, data) => {
    context.commit('setLessonContent', data)
  },
  unsetLessonContent: (context) => {
    context.commit('unsetLessonContent')
  },
  lessonModal: (context, data) => {
    context.commit('lessonModal', data)
  },
  setSectionStatus: (context, data) => {
    context.commit('setSectionStatus', data)
  },
  unsetSectionStatus: (context) => {
    context.commit('unsetSectionStatus')
  },
  setLessonStatus: (context, data) => {
    context.commit('setLessonStatus', data)
  },
  unsetLessonStatus: (context) => {
    context.commit('unsetLessonStatus')
  },
  setContentStatus: (context, data) => {
    context.commit('setContentStatus', data)
  },
  unsetContentStatus: (context) => {
    context.commit('unsetContentStatus')
  },
};

/*
|--------------------------------------------------------------------------
| Getters
|--------------------------------------------------------------------------
*/
const getters = {
  progress: (state) => {
    return state.progress
  },
  section: (state) => {
    return (state.section && Object.keys(state.section).length) ? state.section : {}
  },
  section_data: (state) => {
    return state.section_data
  },
  lessons: (state) => {
    return state.lessons
  },
  lesson_data: (state) => {
    return state.lesson_data
  },
  lesson_content: (state) => {
    return state.lesson_content
  },
  content_id: (state) => (step) => {
    return state.lesson_content[step] ? state.lesson_content[step].content_id : null
  },
  lesson_modal: (state) => {
    return state.lesson_modal
  },
  section_status: (state) => {
    return state.section_status
  },
  lesson_status: (state) => {
    return state.lesson_status
  },
  content_status: (state) => {
    return state.content_status
  },
};

/*
|--------------------------------------------------------------------------
| Export the module
|--------------------------------------------------------------------------
*/
export default {
  state: initialState,
  mutations,
  actions,
  getters
}